import type { ApolloError } from "@apollo/client";
import {
  extractMutationErrorExtension,
  resolveMutationErrorKey,
} from "@/partner/shared/lib/mutationError";

/**
 * Human-readable сообщение об ошибке сохранения тега.
 *
 * `TAG_CUSTOM_FIELD_INVALID` (backend/src/domains/tags/services/
 * validateTagCustomFieldValues.ts) это штатный отказ с появлением
 * обязательных кастомных полей: партнёр не заполнил поле или дал значение
 * не из списка вариантов. Технический `error.message` вида
 * `Custom field "height" is invalid: is required` партнёру нечего чинить,
 * поэтому вместо него показываем перевод с именем поля из `extensions.field`
 * (см. `invalid()` в validateTagCustomFieldValues.ts). Остальные коды
 * (сетевая ошибка, неизвестный отказ) показываются как есть, сырым
 * `error.message`, как было принято в диалогах тега до этой правки.
 */
const TAG_MUTATION_ERROR_KEYS: Record<string, string> = {
  TAG_CUSTOM_FIELD_INVALID: "tags.errors.customFieldInvalid",
};

export function getTagMutationErrorMessage(
  error: ApolloError,
  t: (key: string, options?: Record<string, unknown>) => string
): string {
  const key = resolveMutationErrorKey(error, TAG_MUTATION_ERROR_KEYS, "");
  if (!key) return error.message;

  const field = extractMutationErrorExtension(error, "field") ?? "";
  return t(key, { field });
}
